<script setup lang="ts">
import { computed, type TransitionProps } from "vue";
import { tw } from "../../lib/utils";

interface Props extends TransitionProps {
	top?: boolean;
	bottom?: boolean;
	left?: boolean;
	right?: boolean;
}

const props = defineProps<Props>();

const transitionClass = computed(() => {
	if (props.top) {
		return tw`-translate-y-4`;
	}

	if (props.bottom) {
		return tw`translate-y-4`;
	}

	if (props.left) {
		return tw`-translate-x-4`;
	}

	if (props.right) {
		return tw`translate-x-4`;
	}

	return "";
});

const transitionProps = computed<TransitionProps>(() => {
	return {
		...props,
		enterActiveClass: tw`transition duration-200 ease-out`,
		enterFromClass: tw`transform ${transitionClass.value} opacity-0`,
		enterToClass: tw`transform translate-x-0 translate-y-0 opacity-100`,
		leaveActiveClass: tw`transition duration-75 ease-out`,
		leaveFromClass: tw`transform translate-x-0 translate-y-0 opacity-100`,
		leaveToClass: tw`transform ${transitionClass.value} opacity-0`,
	};
});
</script>

<template>
	<Transition v-bind="transitionProps">
		<slot />
	</Transition>
</template>
